var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"caption",class:[_vm.priorityClass, _vm.invalidClass]},[(_vm.iconName)?_c('svg-icon',{staticClass:"caption__icon",attrs:{"name":_vm.iconName,"width":"16","height":"16"}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }